import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Drawer,
  DrawerHeader,
  DrawerBody,
  DrawerFooter
} from '@one-thd/sui-atomic-components';

const DrawerModal = ({
  isOpen,
  onToggle,
  title,
  children,
  footerActions
}) => {
  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    onToggle(open);
  };

  const handleClose = () => {
    onToggle(false);
  };

  return (
    <Drawer
      open={isOpen}
      onClose={toggleDrawer(false)}
      data-testid="drawer-modal"
    >
      <DrawerHeader title={title} onClose={toggleDrawer(false)} />
      <DrawerBody>
        {children}
      </DrawerBody>
      {footerActions && (
        <DrawerFooter>
          <div className="sui-flex sui-flex-col sui-gap-2">
            {footerActions.map((action, index) => (
              <Button
                key={index}
                fullWidth
                variant={action.variant || 'primary'}
                type={action.type || 'button'}
                disabled={action.disabled || false}
                onClick={() => {
                  if (action.onClick) action.onClick();
                  if (action.closeOnClick !== false) handleClose();
                }}
              >
                {action.label}
              </Button>
            ))}
          </div>
        </DrawerFooter>
      )}
    </Drawer>
  );
};

DrawerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  footerActions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      variant: PropTypes.string,
      type: PropTypes.string,
      onClick: PropTypes.func,
      closeOnClick: PropTypes.bool,
      disabled: PropTypes.bool
    })
  )
};

DrawerModal.defaultProps = {
  footerActions: null
};

export default DrawerModal;
